declare const __MAPS_EMBED_KEY__: string | null;

/** The Google Maps Embed API key (GOOGLE_MAPS_EMBED_KEY at build time); null shows no maps. */
export const mapsEmbedKey: string | null = __MAPS_EMBED_KEY__;

/** An embedded map of one place, for an iframe. */
export const mapEmbedUrl = (key: string, address: string) =>
  `https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(key)}&q=${encodeURIComponent(address)}`;

/** Google Maps directions to an address (no key needed). */
export const directionsUrl = (address: string) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
